export enum ProfileActionType {
  SetState = 'AUTH.SET_STATE',
  GET_DATA = 'AUTH.GET_DATA',
  SAVE_AVATAR = 'AUTH.SAVE_AVATAR',
  CLAIM_CASHBACK = 'AUTH.CLAIM_CASHBACK',
  SAVE_PROFILE_INFO = 'AUTH.SAVE_PROFILE_INFO',
  SAVE_PASSWORD = 'AUTH.SAVE_PASSWORD',
}
